import React from "react";
import { useTheme } from "@mui/material/styles";
import { Tooltip, Typography } from "@mui/material";

interface Props {
  previousAmount: number;
  proportionalToConfigUpdated: boolean;
  contributesToConfigUpdated: boolean;
}
const EmployeeCostSectionAmountHint = ({
  previousAmount,
  proportionalToConfigUpdated,
  contributesToConfigUpdated,
}: Props) => {
  const theme = useTheme();
  return (
    <>
      <Tooltip
        title={`
          Previous amount = ${previousAmount.toLocaleCustom()}.
          It has changed ${
            contributesToConfigUpdated
              ? "due to changes in contributing sections"
              : proportionalToConfigUpdated
              ? "due to changes in proportional to sections or rate"
              : ""
          }`}
      >
        <Typography
          variant="body2"
          color={theme.palette.error.main}
        >
          {previousAmount.toLocaleCustom()}
        </Typography>
      </Tooltip>
    </>
  );
};
export default EmployeeCostSectionAmountHint;
